import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';

const LoginSection: React.FC = () => {
  const {t} = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="flex items-center space-x-4">
      {user ? (
        <>
          <div className="flex items-center">
            <span className="text-sm">{user.email}</span>
          </div>
          <button
            onClick={handleLogout}
            className="bg-black border border-gray-600 hover:border-white text-white px-4 py-1.5 rounded-sm text-sm flex items-center transition duration-300">
            <i className="mr-2 fa fa-sign-out" data-fa-i2svg=""></i>
            {t('common.auth.logout')}
          </button>
        </>
      ) : (
        <button
          onClick={handleLogin}
          className="bg-black border border-gray-600 hover:border-white text-white px-4 py-1.5 rounded-sm text-sm flex items-center transition duration-300">
          <i className="mr-2 fa fa-user" data-fa-i2svg=""></i>
          {t('common.auth.login')}
        </button>
      )}
    </div>
  );
};

export default LoginSection;


